(() => {
  if (window.mulberryClubQA) return;

  let dispose = () => {};
  let refreshTimer;
  let smileInitializationRecovered = false;
  const sectionSelector = '[data-mulberry-club-section]';
  const sourceKeys = ['currency', 'customerVipTier', 'walletSource', 'spendSource', 'pointsProductId', 'referralSource', 'vipSource', 'vipMilestoneLabel'];

  function refresh() {
    window.clearTimeout(refreshTimer);
    dispose();
    dispose = () => {};
    const root = document.getElementById('mulberry-club-page') || document.querySelector('[data-mulberry-club-qa]');
    if (!root) return;
    if (root.id === 'mulberry-club-page') {
      sourceKeys.forEach((key) => { delete root.dataset[key]; });
      root.querySelectorAll(sectionSelector).forEach((section) => {
        sourceKeys.forEach((key) => {
          if (section.dataset[key] !== undefined) root.dataset[key] = section.dataset[key];
        });
      });
    }
    dispose = initialize(root);
  }

  function queueRefresh(event) {
    const root = document.getElementById('mulberry-club-page') || document.querySelector('[data-mulberry-club-qa]');
    if (event && !root?.contains(event.target) && !event.target?.contains?.(root) && !event.target?.matches?.(sectionSelector) && !event.target?.querySelector?.(sectionSelector)) return;
    dispose();
    dispose = () => {};
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 0);
  }

  window.mulberryClubQA = { refresh };
  window.addEventListener('smile-js-initialized', () => {
    if (smileInitializationRecovered) return;
    smileInitializationRecovered = true;
    refresh();
  });
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((eventName) => document.addEventListener(eventName, queueRefresh));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();

  function initialize(root) {
    let active = true;
    const listeners = [];
    const timers = [];
    function listen(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      listeners.push(() => target.removeEventListener(type, handler, options));
    }
    function later(handler, delay) {
      const timer = window.setTimeout(handler, delay);
      timers.push(timer);
      return timer;
    }

    const ribbon = root.querySelector('[data-ribbon]');
    function syncRibbonMode() {
      if (!ribbon) return;
      ribbon.setAttribute('role', 'button');
      ribbon.setAttribute('tabindex', '0');
      ribbon.setAttribute('aria-describedby', ribbon.querySelector('.mulberry-club-qa__ribbon-accessible')?.id || 'mulberry-club-ribbon-copy');
      ribbon.setAttribute('aria-pressed', String(ribbon.dataset.ribbonPaused === 'true'));
      ribbon.setAttribute('aria-label', ribbon.dataset.ribbonPaused === 'true' ? 'Resume scrolling brand messages' : 'Pause scrolling brand messages');
    }
    function toggleRibbon() {
      if (!ribbon) return;
      ribbon.dataset.ribbonPaused = String(ribbon.dataset.ribbonPaused !== 'true');
      syncRibbonMode();
    }
    listen(ribbon, 'click', toggleRibbon);
    listen(ribbon, 'keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggleRibbon();
    });
    syncRibbonMode();

    root.querySelectorAll('[data-smile-panel-link]').forEach((link) => {
      listen(link, 'click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const targetHash = link.hash;
        if (!targetHash) return;
        event.preventDefault();
        // Smile responds to its deep-link hash without reloading the page.
        // Clear an existing matching hash so a second click can reopen the panel.
        if (window.location.hash === targetHash) {
          window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
        }
        window.location.hash = targetHash;
      }, true);
    });

    const balanceElement = root.querySelector('[data-smile-member-balance]');
    const balanceLabel = root.querySelector('[data-smile-member-label]');
    const grid = root.querySelector('[data-smile-earn-grid]');
    const earningMessage = root.querySelector('[data-smile-earning-message]');
    const product = root.querySelector('[data-smile-product]');
    const referral = root.querySelector('[data-smile-referral]');
    const referralCopy = referral?.querySelector('[data-smile-referral-copy]');
    const referralUrl = referral?.querySelector('[data-smile-referral-url]');
    const copyButton = referral?.querySelector('[data-smile-copy-referral]');
    const copyStatus = referral?.querySelector('[data-smile-copy-status]');
    let referralLinkStarted = false;
    let copying = false;
    let copyResetTimer;
    const vip = root.querySelector('[data-smile-vip]');
    const locale = document.documentElement.lang || 'en-US';
    const number = new Intl.NumberFormat(locale);
    let started = false;
    const cards = [...(grid?.querySelectorAll('[data-smile-rule-id]') || [])];
    const liveCards = cards.filter((card) => card.dataset.ruleSource === 'auto');
    const staticCards = cards.filter((card) => card.dataset.ruleSource === 'static' && !card.hidden);
    const needsEarningRules = liveCards.length || vip?.querySelector('[data-smile-vip-points-row]');
    let earningSettled = !needsEarningRules;
    if (staticCards.length) root.dataset.smileEarnings = 'preview';

    function renderDesktopLines(element, text, requestedLines, className) {
      const copy = String(text || '');
      let remainder = copy;
      const lines = [];
      for (const line of requestedLines) {
        if (!line || !remainder.startsWith(`${line} `)) {
          element.textContent = copy;
          return;
        }
        lines.push(line);
        remainder = remainder.slice(line.length + 1);
      }
      if (!lines.length || !remainder) {
        element.textContent = copy;
        return;
      }
      const nodes = [document.createTextNode(lines[0])];
      for (const line of [...lines.slice(1), remainder]) {
        const part = document.createElement('span');
        part.className = className;
        part.textContent = ` ${line}`;
        nodes.push(part);
      }
      element.replaceChildren(...nodes);
    }
    function renderRuleTitle(element, text) {
      const breakAfter = (element.dataset.titleBreakAfter || '').trim();
      renderDesktopLines(element, text, breakAfter ? [breakAfter] : [], 'mulberry-club-qa__desktop-title-line');
    }
    root.querySelectorAll('[data-how-body], [data-how-two-body]').forEach((body) => {
      const desktopLines = (body.dataset.desktopBreaks || '').split('|').map((line) => line.trim()).filter(Boolean);
      renderDesktopLines(body, body.textContent.trim(), desktopLines, 'mulberry-club-qa__desktop-how-line');
    });
    cards.forEach((card) => {
      const title = card.querySelector('[data-smile-rule-title]');
      if (title) renderRuleTitle(title, title.dataset.titleOverride);
    });

    function pointName(amount, settings) {
      return amount === 1 ? (settings?.pointsLabel?.one || 'point').toLowerCase() : (settings?.pointsLabel?.other || 'points').toLowerCase();
    }

    function amountFor(rule, settings) {
      const reward = rule?.rewardValue;
      if (reward?.type === 'fixed' && Number.isFinite(reward.fixed?.value)) {
        const value = reward.fixed.value;
        return `${number.format(value)} ${pointName(value, settings)}`;
      }
      if (reward?.type === 'variable' && Number.isFinite(reward.variable?.value) && Number.isFinite(reward.variable?.perAmount)) {
        const value = reward.variable.value;
        const perAmount = reward.variable.perAmount;
        let spend = `$${number.format(perAmount)}`;
        try {
          spend = new Intl.NumberFormat(locale, { style: 'currency', currency: root.dataset.currency || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(perAmount);
        } catch (_error) {
          spend = `$${number.format(perAmount)}`;
        }
        return `${number.format(value)} ${pointName(value, settings)} for every ${spend} spent`;
      }
      return '';
    }

    function showMessage(message) {
      if (!active || !earningMessage || !liveCards.length || staticCards.length) return;
      earningMessage.textContent = message;
      earningMessage.hidden = false;
    }

    function renderRules(rules, settings) {
      if (!active) return false;
      liveCards.forEach((card) => card.removeAttribute('data-smile-pending'));
      if (!Array.isArray(rules)) {
        liveCards.forEach((card) => { card.hidden = true; });
        showMessage('Current ways to earn are available in the Smile rewards panel.');
        root.dataset.smileEarnings = staticCards.length ? 'preview' : 'unavailable';
        return false;
      }
      const activeRules = new Map(rules.filter((rule) => rule?.id).map((rule) => [String(rule.id), rule]));
      const memberTier = (root.dataset.customerVipTier || '').trim().toLowerCase();
      let count = 0;
      for (const card of liveCards) {
        let rule = activeRules.get(card.dataset.smileRuleId);
        if (card.dataset.smileRuleId === '1208084' && memberTier === 'sweeter') {
          rule = rules.find((item) => item?.rewardValue?.type === 'variable' && /sweeter/i.test(item.name || '') && Array.isArray(item.restrictedToVipTierIds) && item.restrictedToVipTierIds.length) || null;
        }
        const value = amountFor(rule, settings);
        if (!rule?.name || !value) { card.hidden = true; continue; }
        const title = card.querySelector('[data-smile-rule-title]');
        renderRuleTitle(title, title.dataset.titleOverride || rule.name);
        card.querySelector('[data-smile-rule-value]').textContent = value;
        card.hidden = false;
        count++;
      }
      if (!count) showMessage('No mapped ways to earn are currently active.');
      else if (earningMessage) earningMessage.hidden = true;
      root.dataset.smileEarnings = count ? String(count) : staticCards.length ? 'preview' : '0';
      const pointRow = vip?.querySelector('[data-smile-vip-points-row]');
      if (pointRow) {
        const purchaseRules = rules.filter((rule) => rule?.rewardValue?.type === 'variable' && /shop spring & mulberry/i.test(rule.name || ''));
        const sweet = purchaseRules.find((rule) => !/sweeter/i.test(rule.name || ''));
        const sweeter = purchaseRules.find((rule) => /sweeter/i.test(rule.name || ''));
        if (sweet && sweeter) {
          pointRow.querySelectorAll('td')[0].textContent = amountFor(sweet, settings);
          pointRow.querySelectorAll('td')[1].textContent = amountFor(sweeter, settings);
          root.dataset.smileVipRates = 'loaded';
        }
      }
      return count > 0;
    }

    function renderProducts(products) {
      if (!active || !product || root.dataset.spendSource !== 'auto') return;
      product.removeAttribute('data-smile-pending');
      root.querySelector('[data-smile-spend-button]')?.removeAttribute('data-smile-pending');
      const primary = Array.isArray(products) ? products.find((item) => {
        if (!item?.exchangeDescription || !item?.reward?.name) return false;
        return root.dataset.pointsProductId ? String(item.id) === root.dataset.pointsProductId : /order discount/i.test(item.reward.name);
      }) : null;
      if (!primary) {
        product.hidden = true;
        const button = root.querySelector('[data-smile-spend-button]');
        if (button) button.hidden = true;
        root.dataset.smileProducts = 'unavailable';
        return;
      }
      product.querySelector('[data-smile-product-name]').textContent = primary.reward.name;
      product.querySelector('[data-smile-product-rate]').textContent = primary.exchangeDescription;
      product.hidden = false;
      const button = root.querySelector('[data-smile-spend-button]');
      if (button) button.hidden = false;
      root.dataset.smileProducts = String(products.length);
    }

    function clearReferralLink() {
      if (referralCopy) {
        referralCopy.hidden = true;
        referralCopy.removeAttribute('data-smile-pending');
      }
      if (referralUrl) referralUrl.value = '';
      if (copyButton) {
        copyButton.disabled = true;
        copyButton.textContent = copyButton.dataset.copyLabel;
      }
      if (copyStatus) copyStatus.textContent = '';
    }
    clearReferralLink();
    if (referral && root.dataset.referralSource === 'auto') {
      referral.hidden = !window.Shopify?.designMode;
      referral.setAttribute('data-smile-pending', '');
      referralCopy?.setAttribute('data-smile-pending', '');
      const button = referral.querySelector('[data-smile-referral-button]');
      if (button) button.hidden = true;
      root.dataset.smileReferralStatus = 'loading';
      delete root.dataset.smileReferralLink;
    }

    function safeReferralUrl(value) {
      if (typeof value !== 'string' || !value.trim()) return '';
      try {
        const url = new URL(value);
        return ['https:', 'http:'].includes(url.protocol) && url.hostname && !url.username && !url.password ? url.href : '';
      } catch (_error) {
        return '';
      }
    }

    function loadReferralLink(attempt = 0) {
      if (!active || !referralCopy || !referralUrl || !copyButton || root.dataset.smileReferralStatus !== 'active') return;
      try {
        // Smile exposes the authenticated customer's URL from its own cache.
        // Never construct a referral URL from Shopify IDs or preview data.
        const url = safeReferralUrl(window.Smile?.customer?.current?.()?.referralUrl);
        if (url) {
          referralUrl.value = url;
          copyButton.disabled = false;
          referralCopy.hidden = false;
          referralCopy.removeAttribute('data-smile-pending');
          const fallback = referral.querySelector('[data-smile-referral-button]');
          if (fallback) fallback.hidden = true;
          root.dataset.smileReferralLink = 'loaded';
          return;
        }
      } catch (_error) {
        // Keep the existing Smile panel available if its cache is not ready.
      }
      if (attempt < 5) later(() => loadReferralLink(attempt + 1), 1000);
      else {
        root.dataset.smileReferralLink = 'unavailable';
        referralCopy.removeAttribute('data-smile-pending');
        const fallback = referral.querySelector('[data-smile-referral-button]');
        if (fallback) fallback.hidden = false;
      }
    }

    listen(copyButton, 'click', async () => {
      const url = safeReferralUrl(referralUrl?.value);
      if (!active || copying || !url || copyButton.disabled || referralCopy.hidden) return;
      copying = true;
      window.clearTimeout(copyResetTimer);
      try {
        if (typeof window.navigator?.clipboard?.writeText !== 'function') throw new Error('Clipboard unavailable');
        await window.navigator.clipboard.writeText(url);
        if (!active || !referralCopy.isConnected) return;
        copyStatus.textContent = copyButton.dataset.copiedLabel;
        copyResetTimer = later(() => {
          copyStatus.textContent = '';
        }, 3000);
      } catch (_error) {
        if (!active || !referralCopy.isConnected) return;
        referralUrl.focus();
        referralUrl.select();
        copyStatus.textContent = copyButton.dataset.copyHelp;
      } finally {
        copying = false;
      }
    });

    function renderReferral(settings) {
      if (!active || !referral || root.dataset.referralSource !== 'auto') return;
      referral.removeAttribute('data-smile-pending');
      referral.querySelector('[data-smile-referral-button]')?.removeAttribute('data-smile-pending');
      const sender = settings?.senderReward?.name;
      const receiver = settings?.receiverReward?.name;
      if (!sender || !receiver) {
        referral.hidden = !window.Shopify?.designMode;
        const button = referral.querySelector('[data-smile-referral-button]');
        if (button) button.hidden = true;
        clearReferralLink();
        root.dataset.smileReferralStatus = 'inactive';
        return;
      }
      referral.querySelector('[data-smile-sender-reward]').textContent = sender;
      const receiverLabel = referral.querySelector('[data-smile-receiver-reward]');
      const theirBreak = receiver.match(/^(.*\btheir)\s+(.+)$/i);
      if (theirBreak) {
        receiverLabel.replaceChildren(
          document.createTextNode(theirBreak[1]),
          document.createElement('br'),
          document.createTextNode(theirBreak[2])
        );
        receiverLabel.setAttribute('aria-label', receiver);
      } else {
        receiverLabel.textContent = receiver;
        receiverLabel.removeAttribute('aria-label');
      }
      const button = referral.querySelector('[data-smile-referral-button]');
      if (button) button.hidden = Boolean(referralCopy);
      referral.hidden = false;
      root.dataset.smileReferralStatus = 'active';
      if (referralCopy && !referralLinkStarted) {
        referralLinkStarted = true;
        loadReferralLink();
      }
    }

    async function loadWallet() {
      if (!balanceElement || root.dataset.walletSource !== 'auto' || typeof window.Smile?.customerPointsWallet?.get !== 'function') return;
      try {
        const wallet = await window.Smile.customerPointsWallet.get();
        if (!active || !Number.isFinite(wallet?.balance) || !balanceElement.isConnected) return;
        balanceElement.textContent = number.format(wallet.balance);
        if (balanceLabel) balanceLabel.textContent = wallet.balance === 1 ? 'Point available' : 'Points available';
        root.dataset.smileWallet = 'loaded';
      } catch (_error) {
        if (active) root.dataset.smileWallet = 'unavailable';
      }
    }

    async function loadVip() {
      if (!vip || root.dataset.vipSource !== 'auto' || typeof window.Smile?.vipTiers?.get !== 'function') return;
      try {
        const tiers = await window.Smile.vipTiers.get();
        if (!active || !vip.isConnected) return;
        root.dataset.smileVipTiers = Array.isArray(tiers) ? String(tiers.length) : 'unavailable';
        // Smile may return default tier records even when the VIP program is unavailable.
        // Never interpret records alone as proof of an active program or real benefits.
        if (!Array.isArray(tiers) || tiers.length !== 2 || !tiers.every((tier) => tier?.name && Number.isFinite(tier.milestone))) {
          root.dataset.smileVipStatus = 'unconfigured';
          return;
        }
        const sorted = [...tiers].sort((a, b) => a.milestone - b.milestone);
        const names = vip.querySelectorAll('[data-smile-vip-tier-name]');
        const milestones = vip.querySelectorAll('[data-smile-vip-tier-milestone]');
        sorted.forEach((tier, index) => {
          names[index].textContent = tier.name;
          milestones[index].textContent = `${root.dataset.vipMilestoneLabel || 'Milestone'} ${number.format(tier.milestone)}`;
        });
        // Keep the curated comparison rows: the shipping code is a Shopify
        // discount, so it is not present in Smile's VIP perk response.
        vip.querySelector('[data-smile-vip-caption]').textContent = 'Current membership tiers and benefits';
        vip.hidden = false;
        root.dataset.smileVipStatus = 'live';

        const memberTier = vip.querySelector('[data-smile-vip-current]');
        if (memberTier && typeof window.Smile.customerVipStatus?.get === 'function') {
          try {
            const status = await window.Smile.customerVipStatus.get();
            if (!active || !vip.isConnected) return;
            if (status?.vipTier?.id && sorted.some((tier) => tier.id === status.vipTier.id)) {
              memberTier.querySelector('[data-smile-vip-current-name]').textContent = status.vipTier.name;
              memberTier.hidden = false;
              root.dataset.smileCustomerVip = 'loaded';
            } else {
              root.dataset.smileCustomerVip = 'no-tier';
            }
          } catch (_error) {
            if (active) root.dataset.smileCustomerVip = 'unavailable';
          }
        }
      } catch (_error) {
        if (active) root.dataset.smileVipStatus = 'unavailable';
      }
    }

    async function loadProgram() {
      const tasks = [];
      if (needsEarningRules && typeof window.Smile?.earningRules?.get === 'function') tasks.push((async () => {
        async function getEarningRules() {
          let rules;
          for (let attempt = 0; attempt < 3; attempt++) {
            if (!active) return;
            try {
              rules = await window.Smile.earningRules.get();
              if (!active) return;
              if (Array.isArray(rules)) return rules;
            } catch (error) {
              if (!active) return;
              if (attempt === 2) throw error;
            }
            if (attempt < 2) await new Promise((resolve) => later(resolve, 500 * (attempt + 1)));
          }
          return rules;
        }
        try {
          const [rules, settings] = await Promise.all([
            getEarningRules(),
            typeof window.Smile.pointsSettings?.get === 'function' ? window.Smile.pointsSettings.get().catch(() => null) : null
          ]);
          return renderRules(rules, settings);
        } catch (error) {
          renderRules(null);
          throw error;
        } finally {
          if (active) earningSettled = true;
        }
      })());
      if (product && root.dataset.spendSource === 'auto' && typeof window.Smile?.pointsProducts?.get === 'function') tasks.push((async () => {
        try {
          return renderProducts(await window.Smile.pointsProducts.get());
        } catch (error) {
          renderProducts(null);
          throw error;
        }
      })());
      if (referral && root.dataset.referralSource === 'auto' && typeof window.Smile?.referralSettings?.get === 'function') tasks.push((async () => {
        try {
          let settings;
          for (let attempt = 0; attempt < 3; attempt++) {
            if (!active) return;
            try {
              settings = await window.Smile.referralSettings.get();
              if (!active) return;
              if (settings != null) break;
            } catch (error) {
              if (!active) return;
              if (attempt === 2) throw error;
            }
            if (attempt < 2) await new Promise((resolve) => later(resolve, 500 * (attempt + 1)));
          }
          return renderReferral(settings);
        } catch (error) {
          renderReferral(null);
          if (active) root.dataset.smileReferralStatus = 'unavailable';
          throw error;
        }
      })());
      if (root.dataset.vipSource === 'auto') tasks.push(loadVip());
      const results = await Promise.allSettled(tasks);
      if (!active) return;
      root.dataset.smileProgram = results.some((result) => result.status === 'fulfilled') ? 'loaded' : staticCards.length ? 'preview-only' : 'unavailable';
    }

    function start() {
      if (!active || started || !window.Smile) return;
      if (![window.Smile.earningRules, window.Smile.customerPointsWallet, window.Smile.pointsProducts, window.Smile.referralSettings, window.Smile.vipTiers].some((service) => typeof service?.get === 'function')) return;
      started = true;
      loadWallet();
      loadProgram();
    }

    start();
    later(() => {
      if (!active) return;
      // A missing/stalled SDK must not leave reserved blank regions indefinitely.
      root.querySelectorAll('[data-smile-pending]').forEach((element) => element.removeAttribute('data-smile-pending'));
      if (!earningSettled) {
        renderRules(null);
        showMessage('Current program details are available in the Smile rewards panel.');
      }
      if (!started) root.dataset.smileProgram = staticCards.length ? 'preview-only' : 'unavailable';
    }, 12000);
    return () => {
      active = false;
      listeners.forEach((remove) => remove());
      timers.forEach((timer) => window.clearTimeout(timer));
      clearReferralLink();
    };
  }
})();
